import Login from '../containers/Login/Login'
import asyncComponent from '../utils/hoc/asyncComponent'
import { UserRole, Permission } from '../configs/constants/roles.const'

interface RouterProps {
  path: string
  component: any
  needAuthenticate: boolean
  exact?: boolean
  roleAllow?: number[]
  permissions?: string[]
}

const routes: RouterProps[] = [
  {
    path: '/login-error',
    component: Login,
    needAuthenticate: false
  },
  {
    path: '/dashboard',
    component: asyncComponent(() =>
      import('../components/Dashboard/Dashboad').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.ADMIN]
  },
  {
    path: '/user-management',
    component: asyncComponent(() =>
      import('../containers/UserManagement/UserManagement').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.ADMIN]
  },
  {
    path: '/license-key-list',
    component: asyncComponent(() =>
      import('../containers/SNSList/SNSList').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/clinic-list',
    component: asyncComponent(() =>
      import('../containers/ClinicList/ClinicListContent').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/license-package-template',
    component: asyncComponent(() =>
      import('../components/GenerateLicenseKeys/LicensePackageTemplate').then(
        (module) => module.default
      )
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/release-list',
    component: asyncComponent(() =>
      import('../components/ReleaseList/ReleaseList').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/release-note',
    component: asyncComponent(() =>
      import('../components/ReleaseNote/ReleaseNoteManagement').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/notification',
    component: asyncComponent(() =>
      import('../components/Notification/NotificationManagement').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/locale-setting',
    component: asyncComponent(() =>
      import('../components/LocaleSetting/LocaleSetting').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/auto-download-management',
    component: asyncComponent(() =>
      import('../components/AutoDownloadManagement/AutoDownloadManagement').then(
        (module) => module.default
      )
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/sales-area-management',
    component: asyncComponent(() =>
      import('../components/SalesAreaManagement/SalesAreaManagement').then(
        (module) => module.default
      )
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.ES, UserRole.ADMIN]
  },
  {
    path: '/audit-logs',
    component: asyncComponent(() =>
      import('../components/AuditLog/AuditLog').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.ADMIN]
  },
  {
    path: '/eai-licenses',
    component: asyncComponent(() =>
      import('../components/EAILicenses/EAILicenses').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.AFFILIATE, UserRole.ES, UserRole.ADMIN],
    permissions: [Permission.EAI_LICENSES]
  },
  {
    path: '/product',
    component: asyncComponent(() =>
      import('../components/Product/Product').then((module) => module.default)
    ),
    needAuthenticate: true,
    exact: true,
    roleAllow: [UserRole.ADMIN],
    permissions: [Permission.PRODUCT_PERMISSION]
  }
]

export default routes
